import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-product',
  templateUrl: './delete-product.component.html',
  styleUrls: ['./delete-product.component.css']
})
export class DeleteProductComponent implements OnInit {

  data: any;
  modelSubtitle = false
  product:any = []
  checked = false
  name = ""
  version = ""
  code = ""
  group = ""
  description = ""
  isActive = false
  i: any;
  deleteId: any = "";

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;


  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllProduct(this.pageNumber,this.recordsPerPage)
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllProduct(this.pageNumber-1,this.recordsPerPage)
  }
 

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllProduct(pageNumber:any,recordsPerPage:any){
    this.generic_service.getProduct(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.product = response.response.productMasterList;
        this.totalRecords = response.response.totalRecords;
      }
    )
  }

  checkPage(){
    let pageNumber = 0
    if(this.pageNumber == 0){
      pageNumber = this.pageNumber
    }else{
      pageNumber = this.pageNumber-1
    }
  }
 
  deleleProduct(){
    this.generic_service.delProduct(this.deleteId).subscribe(
      (res:any)=>{
        this.checkPage()
        this.toastr.success("Successfully Deleted");
        this.getAllProduct(this.pageNumber-1,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

}
